import { Instagram, MessageCircle, SlidersHorizontal } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { LEGAL, scrollToId, waLink } from "../lib/constants";

const links = [
  { label: "Nossos Projetos", hash: "#projetos", testid: "nav-link-portfolio" },
  { label: "Serviços", hash: "#servicos", testid: "nav-link-services" },
  { label: "Escritório", hash: "#sobre", testid: "nav-link-about" },
  { label: "Solicitar Projeto", hash: "#solicitar", testid: "nav-link-custom-project" },
];

export const HeaderNav = () => (
  <header
    data-testid="header-nav"
    className="fixed inset-x-0 top-0 z-40 border-b border-slate-900/10 bg-white/80 backdrop-blur-md"
  >
    <div className="mx-auto flex h-20 max-w-7xl items-center gap-6 px-5 sm:px-8 lg:gap-12">
      <a href="#topo" onClick={(e) => { e.preventDefault(); scrollToId("#topo"); }} aria-label="Início">
        <Logo />
      </a>

      <nav className="ml-auto hidden items-center gap-8 md:flex">
        {links.map((l) => (
          <a
            key={l.hash}
            href={l.hash}
            data-testid={l.testid}
            onClick={(e) => { e.preventDefault(); scrollToId(l.hash); }}
            className="font-mono text-[11px] uppercase tracking-[0.22em] text-slate-600 transition-colors hover:text-[#C05621]"
          >
            {l.label}
          </a>
        ))}
      </nav>

      <div className="ml-auto flex items-center gap-2 md:ml-0">
        <a
          href={LEGAL.instagram}
          target="_blank"
          rel="noreferrer"
          data-testid="header-instagram-link"
          aria-label="Instagram da ZARI ENGENHARIA"
          className="flex h-10 w-10 items-center justify-center border border-slate-900/15 text-slate-600 transition-colors hover:border-slate-900 hover:text-[#C05621]"
        >
          <Instagram size={17} strokeWidth={1.7} />
        </a>
        <Link
          to="/admin"
          data-testid="nav-link-admin"
          aria-label="Painel administrativo"
          className="hidden h-10 w-10 items-center justify-center border border-transparent text-slate-400 transition-colors hover:border-slate-900/15 hover:text-slate-900 sm:flex"
        >
          <SlidersHorizontal size={17} strokeWidth={1.6} />
        </Link>
        <a
          href={waLink("Olá! Vim pelo site da ZARI ENGENHARIA e gostaria de mais informações.")}
          target="_blank"
          rel="noreferrer"
          data-testid="header-contact-button"
          className="flex h-10 items-center gap-2 border border-slate-900 bg-slate-900 px-4 font-mono text-[11px] uppercase tracking-[0.2em] text-white transition-colors hover:border-[#C05621] hover:bg-[#C05621]"
        >
          <MessageCircle size={15} strokeWidth={1.8} />
          <span className="hidden sm:inline">Contato</span>
        </a>
      </div>
    </div>
  </header>
);
